import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { PLACEMENT_STATUS_LABELS } from "../../../constants/automapFeaturedPlacementConstants";
import { fetchPlacementSchedule } from "../../../services/automapFeaturedPlacementApi";
import { AdminPlacementsNav } from "./AdminPlacementsShared";

export default function AdminPlacementSchedulePage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [slotFilter, setSlotFilter] = useState("");
  const [cityFilter, setCityFilter] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchPlacementSchedule({
        slot: slotFilter || undefined,
        city: cityFilter || undefined,
      });
      setRows(data.schedule || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [slotFilter, cityFilter]);

  useEffect(() => {
    load();
  }, [load]);

  const overlaps = useMemo(() => {
    const warnings = [];
    for (let i = 0; i < rows.length; i += 1) {
      for (let j = i + 1; j < rows.length; j += 1) {
        const a = rows[i];
        const b = rows[j];
        if (a.slotKey !== b.slotKey) continue;
        const aStart = new Date(a.startAt).getTime();
        const aEnd = new Date(a.endAt).getTime();
        const bStart = new Date(b.startAt).getTime();
        const bEnd = new Date(b.endAt).getTime();
        if (aStart < bEnd && bStart < aEnd) {
          warnings.push(`${a.placementName || a.id} ↔ ${b.placementName || b.id} (${a.slotKey})`);
        }
      }
    }
    return warnings;
  }, [rows]);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Destacados" title="Calendario de placements" description="Programación activa y futura. Detecta solapamientos por slot." />
      <AdminAutomotiveNav active="placements" />
      <AdminPlacementsNav active="schedule" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <input placeholder="Filtrar ciudad" value={cityFilter} onChange={(e) => setCityFilter(e.target.value)} />
          <input placeholder="Filtrar slot" value={slotFilter} onChange={(e) => setSlotFilter(e.target.value)} />
          <button type="button" className="admin-btn" onClick={load}>Actualizar</button>
        </div>
        {overlaps.length ? (
          <div className="dealer-state-box" style={{ borderColor: "#c0392b" }}>
            <strong>Solapamientos detectados</strong>
            <ul>{overlaps.map((w) => <li key={w}>{w}</li>)}</ul>
          </div>
        ) : null}
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading ? (
          <div className="import-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Placement</th>
                  <th>Dealer</th>
                  <th>Slot</th>
                  <th>Estado</th>
                  <th>Prioridad</th>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Ciudad</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.placementName || row.listingTitle || row.id}</td>
                    <td>{row.dealerName}</td>
                    <td>{row.slotKey}</td>
                    <td>{PLACEMENT_STATUS_LABELS[row.runtimeStatus] || row.runtimeStatus}</td>
                    <td>{row.priority}</td>
                    <td>{row.startAt?.replace("T", " ").slice(0, 16)}</td>
                    <td>{row.endAt?.replace("T", " ").slice(0, 16)}</td>
                    <td>{row.city || row.dealerCity || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
        <p className="muted">
          <Link to="/admin/placements/listings">Crear placement</Link> · Prioridad mayor gana en slots compartidos.
        </p>
      </main>
    </AdminPageLayout>
  );
}
